import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueRouter from "vue-router";

Vue.use(BootstrapVue)
Vue.use(VueRouter);
const router = new VueRouter();

import '@/assets/custom.scss'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')